export function getSelectedSportMenuItemType(treeItems: any[]): SportMenuItemType | null {
    const numberOfLevels = treeItems.length;
    // Only three levels are expected in the sport
    // menu: Sport > Category > Tournament
    if (numberOfLevels < 1 || numberOfLevels > 3) {
        return null;
    }
    const levelToType: Record<number, SportMenuItemType> = {
        1: SportMenuItemType.Sport,
        2: SportMenuItemType.Category,
        3: SportMenuItemType.Tournament,
    };
    return levelToType[numberOfLevels];
}

export function getSportMenuData(treeItems: any[]): { menuType: string; menuValue: string } | Record<string, unknown> {
    const menuType = getSelectedSportMenuItemType(treeItems);
    // Empty value is an empty object since the caller is deconstructing
    // the returned value
    if (!menuType) {
        return {};
    }
    return {
        menuType,
        menuValue: treeItems[treeItems.length - 1].name,
    };
}

export function stringifyBool(value: boolean): string {
    return value ? 'TRUE' : 'FALSE';
}

export enum SportMenuItemType {
  Sport = 'Sport',
  Category = 'Category',
  Tournament = 'Tournament',
}
